<template>
		<Button type="primary" @click="countDown">
			 {{content}}
		</Button>
</template>

<script>
	import http from '@/http/http.js'
	let _this
	let clock
	export default{
		data () {
		  return {
		   content: '发送验证码',  // 按钮里显示的内容
		   totalTime: 60      //记录具体倒计时时间
		  }
		},
		created() {
			_this=this
			 window.clearInterval(clock)
		},
		props:['phone','codeType'],
		methods: {
		  countDown() {
			if(_this.phone=='' || _this.phone==null){
				_this.$Message.warning('请输入手机号');
				return ;
			}
			if (_this.totalTime !=60) {
				return ;
			}
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/note/send/emp',
			    data: {phone:_this.phone,codeType:_this.codeType},
				_this: _this,
				success: function(data) {
					_this.$Message.success('验证码发送成功');
				}
			 })
			
		    clock = window.setInterval(() => {
		      _this.totalTime--
		      _this.content = _this.totalTime + 's后重新发送'
			  if (_this.totalTime < 0) {     //当倒计时小于0时清除定时器
				  window.clearInterval(clock)
				  _this.content = '重新发送验证码'
				  _this.totalTime = 60
				}
		    },1000)
		  }
		}
	}
	
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/comm/noteSend.vue